export const RESET_STATE = 'TRANSLATE_RESET_STATE';
export const REQUEST_LOADING = 'TRANSLATE_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'TRANSLATE_REQUEST_SUCCESS';
export const REQUEST_FAILED = 'TRANSLATE_REQUEST_FAILED';
